import {useMemo, useCallback} from 'react'
import {
  yymmToYearMonth,
  currentYyMm as getCurrentYyMm,
  monthLabelFromYyMm,
} from '@common/utils'

type UseMonthNavigationProps = {
  currentYyMm: string
  onMonthChange: (yyMm: string) => void
}

export const useMonthNavigation = ({
  currentYyMm,
  onMonthChange,
}: UseMonthNavigationProps) => {
  const monthLabel = useMemo(
    () => monthLabelFromYyMm(currentYyMm),
    [currentYyMm],
  )

  const disablePrev = useMemo(
    () => currentYyMm === getCurrentYyMm(),
    [currentYyMm],
  )

  const gotoPrevMonth = useCallback(() => {
    const {year, month} = yymmToYearMonth(currentYyMm)
    const d = new Date(year, month - 2, 1)
    const newYY = String(d.getFullYear()).slice(-2)
    const newMM = String(d.getMonth() + 1).padStart(2, '0')
    onMonthChange(`${newYY}${newMM}`)
  }, [currentYyMm, onMonthChange])

  const gotoNextMonth = useCallback(() => {
    const {year, month} = yymmToYearMonth(currentYyMm)
    const d = new Date(year, month, 1)
    const newYY = String(d.getFullYear()).slice(-2)
    const newMM = String(d.getMonth() + 1).padStart(2, '0')
    onMonthChange(`${newYY}${newMM}`)
  }, [currentYyMm, onMonthChange])

  return {
    gotoPrevMonth,
    gotoNextMonth,
    monthLabel,
    disablePrev,
  }
}
